import {Component, Input, OnInit} from '@angular/core';

type IconName = 'home' | 'done' | 'failed' | 'documents' | 'star-full' | 'trash'
  | 'team' | 'invited-users' | 'user-indicator' | 'fired';

const LUCIDE_ICON_MAP: { [key in IconName]: string } = {
  'home': 'house',
  'done': 'check',
  'failed': 'x',
  'documents': 'files',
  'star-full': 'star',
  'trash': 'trash-2',
  'team': 'users',
  'invited-users': 'mail',
  'user-indicator': 'user-plus',
  'fired': 'user-x',
};

@Component({
  selector: 'ui-category-block-header-control',
  templateUrl: './ui-category-block-header-control.component.html',
  styleUrls: ['./ui-category-block-header-control.component.less']
})
export class UiCategoryBlockHeaderControlComponent implements OnInit {
  @Input() icon: IconName;
  @Input() color: 'green' | 'yellow' | 'blue' | 'red';
  @Input() isActive;
  cssClass: string[] = [];
  lucideName: string;
  @Input() tooltip: string;

  constructor() {
  }

  ngOnInit() {
    this.cssClass.push('ui-category-block-header-control__icon_' + this.color);
    this.lucideName = LUCIDE_ICON_MAP[this.icon] || this.icon;
  }
}
